/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../../services/Axios/axios";
import RenderLoanPage from "../RenderLoanPage";

function SentSettlements() {
  const history = useHistory();
  const [settlements, setSettlements] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetch = async () => {
      setIsLoading(true);
      try {
        const res = await axiosInstance.get("/settlement?status=processed");
        setSettlements(res.data || []);
      } catch {
        toast.error("Failed to load sent settlements.");
      } finally {
        setIsLoading(false);
      }
    };
    fetch();
  }, []);

  const filtered = settlements.filter((s) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      s.member_name?.toLowerCase().includes(q) ||
      s.staff_id?.toLowerCase().includes(q) ||
      s.loan_id?.toLowerCase().includes(q) ||
      s.loan_officer_name?.toLowerCase().includes(q)
    );
  });

  const fmt = (date) =>
    date ? new Date(date).toLocaleDateString("en-GB") : "—";

  const fmtAmount = (amt) =>
    amt != null
      ? "GHS " +
        Number(amt).toLocaleString("en-GH", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "—";

  return (
    <RenderLoanPage title="Sent Settlements">
      <ToastContainer />

      {/* Summary badge */}
      <div style={{ marginBottom: 16 }}>
        <span
          style={{
            background: "#e8f5e9",
            color: "#2e7d32",
            border: "1px solid #81c784",
            padding: "5px 16px",
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 700,
          }}
        >
          {filtered.length} Processed Settlement{filtered.length !== 1 ? "s" : ""}
        </span>
      </div>

      {/* Search */}
      <div style={{ marginBottom: 18 }}>
        <input
          type="text"
          placeholder="Search by name, staff ID, loan ID or loan officer..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            padding: "9px 14px",
            border: "1px solid #ddd",
            borderRadius: 8,
            fontSize: 14,
            width: "100%",
            maxWidth: 460,
            outline: "none",
            boxSizing: "border-box",
          }}
        />
      </div>

      {/* Table */}
      <div
        style={{
          background: "#fff",
          borderRadius: 10,
          boxShadow: "0 1px 8px rgba(0,0,0,0.07)",
          overflow: "hidden",
        }}
      >
        {isLoading ? (
          <div style={{ textAlign: "center", padding: 60, color: "#888" }}>
            Loading...
          </div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: 60, color: "#888" }}>
            No sent settlements found.
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table
              style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}
            >
              <thead>
                <tr style={{ background: "#2d6a4f" }}>
                  {[
                    "#",
                    "Member Name",
                    "Staff ID",
                    "Loan ID",
                    "Amount (GHS)",
                    "Issue Date",
                    "Last Payment Date",
                    "Loan Officer",
                    "Status",
                    "Action",
                  ].map((h) => (
                    <th
                      key={h}
                      style={{
                        padding: "12px 14px",
                        textAlign: "left",
                        fontWeight: 700,
                        color: "#fff",
                        whiteSpace: "nowrap",
                        borderBottom: "2px solid #1b4332",
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((s, idx) => (
                  <tr
                    key={s._id}
                    style={{
                      background: idx % 2 === 0 ? "#fff" : "#f9fafb",
                      borderBottom: "1px solid #f0f0f0",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      history.push(`/loans/settlement-detailed?id=${s._id}`)
                    }
                  >
                    <td style={td}>{idx + 1}</td>
                    <td style={{ ...td, fontWeight: 600 }}>{s.member_name}</td>
                    <td style={td}>{s.staff_id}</td>
                    <td style={td}>{s.loan_id || "—"}</td>
                    <td style={{ ...td, fontWeight: 700, color: "#1b5e20" }}>
                      {fmtAmount(s.amount)}
                    </td>
                    <td style={td}>{fmt(s.issue_date)}</td>
                    <td style={td}>{fmt(s.last_expected_payment_date)}</td>
                    <td style={td}>{s.loan_officer_name || "—"}</td>
                    <td style={td}>
                      <span
                        style={{
                          background: "#e8f5e9",
                          color: "#2e7d32",
                          border: "1px solid #81c784",
                          padding: "3px 10px",
                          borderRadius: 20,
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                      >
                        Processed
                      </span>
                    </td>
                    <td style={td}>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          history.push(
                            `/loans/settlement-detailed?id=${s._id}`
                          );
                        }}
                        style={{
                          background: "#1565c0",
                          color: "#fff",
                          border: "none",
                          borderRadius: 6,
                          padding: "6px 14px",
                          fontSize: 12,
                          cursor: "pointer",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </RenderLoanPage>
  );
}

const td = {
  padding: "11px 14px",
  color: "#444",
  verticalAlign: "middle",
  whiteSpace: "nowrap",
};

export default SentSettlements;
